module.exports = __webpack_public_path__ + "img/woocommerce-logo.e783a09b.svg";